var module = angular.module('octopusApp.projects');

module.directive('certificatePrivateKeyAccess', function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            action: '=',
            project: '=',
            localNames: '='
        },
        templateUrl: 'areas/projects/actions/certificate_import/certificate_private_key_access.html',
        controller: function($scope, $uibModal) {

            $scope.accessRules = [];

            $scope.$watch(function() { return $scope.action.Properties["Octopus.Action.Certificate.PrivateKeyAccessRules"]; }, function(newVal) {
                $scope.accessRules = accessRulesFromString(newVal);
            });

            $scope.addAccessRule = function() {
                $uibModal.open({
                    size: "lg",
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/projects/actions/certificate_import/certificate_private_key_access_rule_dialog.html',
                    controller: "CertificatePrivateKeyAccessRuleDialogController",
                    resolve: {
                        "projectId": function() {
                            return $scope.project.Id;
                        },
                        "accessRule": function() {
                            return {
                                Identity: null,
                                Access: 'ReadOnly'
                            };
                        }
                    }

                }).result.then(function(result){
                    if (!result) {
                        return;
                    }

                    $scope.accessRules.push(result);
                    updateProperties($scope.accessRules);
                });
            };

            $scope.editAccessRule = function(accessRule) {
                $uibModal.open({
                    size: "lg",
                    backdrop: true,
                    keyboard: true,
                    templateUrl: 'areas/projects/actions/certificate_import/certificate_private_key_access_rule_dialog.html',
                    controller: "CertificatePrivateKeyAccessRuleDialogController",
                    resolve: {
                        "projectId": function() {
                            return $scope.project.Id;
                        },
                        "accessRule": function() {
                            return _.clone(accessRule);
                        }
                    }

                }).result.then(function(result){
                    if (!result) {
                        return;
                    }

                    var ix = _.indexOf($scope.accessRules, accessRule);
                    $scope.accessRules[ix] = result;
                    updateProperties($scope.accessRules);
                });
            };

            $scope.deleteAccessRule = function(accessRule) {
                var ix = _.indexOf($scope.accessRules, accessRule);
                $scope.accessRules.splice(ix, 1);
                updateProperties($scope.accessRules);
            };


            function updateProperties(accessRules) {
               $scope.action.Properties["Octopus.Action.Certificate.PrivateKeyAccessRules"] = accessRulesToString(accessRules);
            }

            function accessRulesToString(accessRules) {
                return JSON.stringify(accessRules);
            }

            function accessRulesFromString(actionRulesString) {
                return JSON.parse(actionRulesString);
            }
        }
    };
});

module.controller('CertificatePrivateKeyAccessRuleDialogController', function($scope, $uibModalInstance, busy, accessRule, projectId) {
    $scope.isSaving = busy.create();
    $scope.accessRule = accessRule;
    $scope.projectId = projectId;

    $scope.close = function() {
        $uibModalInstance.close();
    };

    $scope.save = function() {

        if (!$scope.accessRule.Identity) {
           $scope.isSaving.showError('An identity must be provided');
            return;
        }

        $uibModalInstance.close($scope.accessRule);
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/certificate_import/certificate_private_key_access.js
// module id = 979927211994296
// module chunks = 1